import { Outlet } from 'react-router-dom';
import { ReportsProvider, useReportsStore } from '../stores/reportsStore';
import withStoreProvider from '../../../utils/withStoreProvider';
import { useKeycloakStore } from '../../../shared_stores';
import { Flex } from '@mantine/core';
import { LoadingElement } from '../../../shared_components';
import { observer } from 'mobx-react-lite';
import { reportsStore } from '../stores';
import { ReportsErrorPage } from './reportsErrorPage';

const ReportBaseContent = observer(() => {
  const store = useReportsStore();
  const kcStore = useKeycloakStore();
  const params = new URLSearchParams(window.location.search);
  const paymentToken = params.get('token');

  if (!store.loadedMeasurementData) {
    if (store.failedLoadingMeasurementList) {
      return <ReportsErrorPage />;
    } else if (kcStore.authenticated) {
      void store.loadAllMeasurements(kcStore.token);
    } else if (paymentToken) {
      void store.loadMeasurementFromPaymentToken(paymentToken);
    }
    return (
      <Flex
        direction={'column'}
        justify={'center'}
        style={{
          height: '100%',
          width: '100%',
          backgroundColor: 'var(--mantine-color-clinicalWhite-0)',
        }}
      >
        <LoadingElement />
      </Flex>
    );
  }
  return <Outlet />;
});

export const ReportBase = withStoreProvider(
  reportsStore,
  ReportsProvider,
)(ReportBaseContent);
